






























import { Component, Vue, Watch } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import ResizeMixin from './resizeMixin'
import AppHeader from './header.vue'
import Breadcrumb from './breadcrumb.vue'
import Menubar from './menu.vue'
import { mixins } from 'vue-class-component'
import sysLocalStorage, { enStorageName } from '@/store/localStorage'
import { UserData } from '@/api/systemManage/user'
import { formatDateTimess } from '@/configs/filters'
import { getNewEvents } from '@/api/hikEvent'
import { getNewestId } from '@/api/systemManage/notification'
import NotificationView from '@/components/systemManage/notification/view.vue'
import { tryToBool } from '@/configs/functions'

const AppModule = namespace('app')
const UserModule = namespace('user')
@Component({
  components: {
    AppHeader, Menubar, Breadcrumb, NotificationView
  }
})
export default class Layout extends mixins(ResizeMixin) {
  public name = 'layout'

  public copyright: string = window.baseConfig.Copyright
  public icpNo: string = window.baseConfig.ICPNo
  public icpUrl: string = window.baseConfig.ICPUrl

  @AppModule.Getter
  public webStyle!: string

  // get pageStyle(): any {
  //   if (this.isDashboard) {
  //     return 'padding:5px;'
  //   }
  //   return ''
  // }

  get isDashboard(): boolean {
    const path = this.$route.path.toLowerCase()
    let dashboard = (path == '/dashboard' || path == '/' || path == '')
    return dashboard
  }

  public get showBreadcrumb(): boolean {
    return !this.isDashboard
  }

  public get showPwdTips(): boolean {
    return +sysLocalStorage.getItem(enStorageName[enStorageName.ChangePwdTips]) == 1
  }
  @UserModule.Getter('userInfo')
  public curUser!: UserData

  public openModifyPwdDialog() {
    var info = {
      userId: this.curUser.Id,
      isNotice: true
    }
    window.eventBus.$emit('UserModifyPwd_Open', info)
    // this.$notify.warning({
    //   title: '提示',
    //   position: 'bottom-right',
    //   duration: 0,
    //   dangerouslyUseHTMLString: true,
    //   message: '您的密码过于简单，不符合等保要求，请重新设定！<br/>*密码长度至少8位，需包含数字、字母及特殊字符中的两种。'
    // })
  }
  public created() {
  }
  public mounted() {
    if (this.showPwdTips) {
      this.openModifyPwdDialog()
    }
    // console.log('this.sidebar.opened', this.sidebar.opened)
    //默认关闭
    var hidden = sysLocalStorage.getItem(enStorageName[enStorageName.HiddenSidebar])
    //有设置过隐藏菜单（1.登陆时只有一个菜单时隐藏菜单。2.客户点击隐藏菜单）
    if (hidden == '1') {
      this.sidebar.opened = false
    }
    else {
      this.sidebar.opened = !window.baseConfig.HiddenMenu
    }
    this.fetchData()
  }
  @UserModule.Getter('accessList')
  public accessList!: string[]
  public fetchData() {
    var hasHikEvent: boolean = false
    var hasNotify: boolean = false
    const list = this.accessList
    if (list && list.length > 0) {
      hasHikEvent = list.findIndex((e: string) => e == '/HikEvent') > -1
      hasNotify = list.findIndex((e: string) => e == '/Announcements') > -1
    }
    if (hasHikEvent) {
      this.loadHikEvents()
    }
    if (hasNotify) {
      this.fetchNotify()
    }
  }
  public loadHikEvents() {
    window.hikEventTimer = setInterval(this.fetchHikEvents, 5 * 1000)
  }
  //解决多条 notify 重叠问题
  public notifyPromise: any = Promise.resolve()
  public fetchHikEvents() {
    getNewEvents().then((response: { data: any }) => {
      const data = response.data
      if (data) {
        var events = data
        events.forEach((e: any) => {
          var dt = formatDateTimess(e.HappenTime)
          var className = (e.EventLvl == 3 ? 'notify-danger' : '')
          this.notifyPromise = this.notifyPromise.then(this.$nextTick)
            .then(() => {
              this.$notify({
                title: e.EventTypeName,
                message: '[' + dt + ']' + e.SrcName,
                type: 'warning',
                customClass: className,
                position: 'top-right',
                duration: 0,//不会自动关闭
                onClick: () => {
                  window.eventBus.$emit('viewHikEvent', e.Id)
                }
              })
            })
        })
      }
    })
  }
  public fetchNotify() {
    getNewestId().then((response: { data: any }) => {
      const data = response.data
      if (data) {
        if (data > 0) {
          window.eventBus.$emit('viewNotification', data)
        }
      }
    })
  }
  public beforeDestroy() {
    if (window.hikEventTimer) {
      clearInterval(window.hikEventTimer)
    }
  }
}
